import React from "react";
import { connect } from "react-redux";
import Carousel from "react-elastic-carousel";
import { Link } from "react-router-dom";
const breakPoints = [
  { width: 1, itemsToShow: 1 },
  { width: 550, itemsToShow: 2, itemsToScroll: 2 },
  { width: 768, itemsToShow: 3 },
  { width: 1200, itemsToShow: 5 },
];

function Topitems({ products }) {
  return (
    <div>
      <div className="seperator"></div>
      <h2>Consider This Top Products</h2>
      <div className="items">
        <Carousel breakPoints={breakPoints}>
          {products
            .map((items) => {
              return (
                <div className="topitems" key={items.id}>
                  <Link to={`/product/${items.id}`}>
                    <img src={items.img} width="150vw" alt={items.title} />
                    <div className="topitems_details">
                      <h3>{items.title}</h3>
                      <h4>${items.price}</h4>
                    </div>
                  </Link>
                </div>
              );
            })
            .slice(0, 7)}
        </Carousel>
      </div>
      <div className="seperator"></div>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    products: state.store.products,
  };
};
export default connect(mapStateToProps)(Topitems);
